import { render, staticRenderFns } from "./YogaPlace.vue?vue&type=template&id=44963880&scoped=true&"
import script from "./YogaPlace.vue?vue&type=script&lang=js&"
export * from "./YogaPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44963880",
  null
  
)

export default component.exports